<template>
  <div class="car-content-introduction">
    <span class="car-headline">
      {{ $t(bookingTitle, {firstname: booking.givenname, lastname: booking.surname}) }}
    </span>
    <p>{{ $t(bookingDescription, {firstname: booking.givenname, lastname: booking.surname}) }}</p>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'BookingDescription',
  data() {
    return {
      bookingTitle: '',
      bookingDescription: ''
    }
  },
  props: {
    booking: {
      required: 'required'
    }
  },
  created() {
    if (this.booking.status === 'OFFERED') {
      this.bookingDescription = 'quote.description';
      this.bookingTitle = 'quote.title';

      if (!(_.get(this, 'booking.surname') && _.get(this, 'booking.givenname'))) {
        this.bookingTitle = 'quote.titleAnonymous';
        this.bookingDescription = 'quote.descriptionAnonymous';
      }
    } else if (this.booking.status === 'CANCELLED') {
      this.bookingDescription = 'booking.cancel.description';
      this.bookingTitle = 'booking.title';

      if (!(_.get(this, 'booking.surname') && _.get(this, 'booking.givenname'))) {
        this.bookingTitle = 'booking.titleAnonymous';
        this.bookingDescription = 'booking.descriptionAnonymous';
      }
    } else {
      this.bookingDescription = 'booking.description';
      this.bookingTitle = 'booking.title';

      if (!(_.get(this, 'booking.surname') && _.get(this, 'booking.givenname'))) {
        this.bookingTitle = 'booking.titleAnonymous';
        this.bookingDescription = 'booking.descriptionAnonymous';
      }
    }
  }
};
</script>
